import { render, staticRenderFns } from "./ItemHistories.vue?vue&type=template&id=3c756cd7&"
import script from "./ItemHistories.vue?vue&type=script&lang=js&"
export * from "./ItemHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports